import React, { useEffect, useState } from "react";
import { Select, Button, Modal, Input, Space, message } from "antd";
import { useNavigate } from "react-router-dom";
import pushTemplateApi from "../../../api/push-template-api";

/**
 * Điều khiển mẫu nội dung trong form: chọn mẫu để áp vào form (chỉ nội dung, không
 * động tới đối tượng nhận) + lưu nội dung hiện tại thành mẫu mới.
 * Props:
 *   onApply(template): áp template vào form
 *   collectContent(): () => { title, message, path, url, ...richOptions } | null nếu thiếu title/message
 */
function PushTemplateControls({ onApply, collectContent }) {
    const navigate = useNavigate();
    const [templates, setTemplates] = useState([]);
    const [selected, setSelected] = useState(undefined);
    const [saveOpen, setSaveOpen] = useState(false);
    const [name, setName] = useState("");
    const [saving, setSaving] = useState(false);

    const fetchTemplates = async () => {
        try {
            const { data } = await pushTemplateApi.listTemplates();
            setTemplates(data.data.items || []);
        } catch {
            /* im lặng — không chặn form nếu lỗi tải mẫu */
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, []);

    const handleApply = (id) => {
        setSelected(id);
        const tpl = templates.find((t) => t.id === id);
        if (tpl) {
            onApply(tpl);
            message.success(`Đã áp mẫu "${tpl.name}"`);
        }
    };

    const handleSave = async () => {
        const content = collectContent();
        if (!content) {
            message.warning("Cần có tiêu đề và nội dung trước khi lưu mẫu");
            return;
        }
        if (!name.trim()) {
            message.warning("Nhập tên mẫu");
            return;
        }
        try {
            setSaving(true);
            await pushTemplateApi.createTemplate({ name: name.trim(), ...content });
            message.success("Đã lưu mẫu");
            setSaveOpen(false);
            setName("");
            fetchTemplates();
        } catch (err) {
            message.error(err?.response?.data?.message || "Lưu mẫu thất bại");
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <Space wrap>
                <Select
                    placeholder="Chọn mẫu để áp"
                    style={{ minWidth: 200 }}
                    value={selected}
                    onChange={handleApply}
                    options={templates.map((t) => ({ value: t.id, label: t.name }))}
                    notFoundContent="Chưa có mẫu"
                    allowClear
                    onClear={() => setSelected(undefined)}
                />
                <Button onClick={() => setSaveOpen(true)}>Lưu thành mẫu</Button>
                <Button type="link" onClick={() => navigate("/push/templates")}>
                    Quản lý mẫu
                </Button>
            </Space>

            <Modal
                title="Lưu nội dung thành mẫu"
                open={saveOpen}
                onOk={handleSave}
                confirmLoading={saving}
                onCancel={() => setSaveOpen(false)}
                okText="Lưu"
                cancelText="Hủy"
            >
                <Input
                    placeholder="Tên mẫu (vd: Khuyến mãi cuối tuần)"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onPressEnter={handleSave}
                />
            </Modal>
        </>
    );
}

export default PushTemplateControls;
